export class Constants {
  static MOBILE_MAX_WIDTH = 992;
  static SMALL_DESKTOP_HEIGHT = 657;
  static TABLET_MAX_WIDTH = 1279;
  static SMALL_DESKTOP_MAX_WIDTH = 1919;
  static NON_MOBILE_MIN_WIDTH = 1200;
  static DEFAULT_WAIT_TIMEOUT = 3000;
  static DATE_TIME_FORMAT = 'DD-MM-YYYY HH:mm';
  static DATE_DAY_ONLY = 'DD/';
  static TIME_FORMAT_HOURADDITION = ' - HH:mm';
  static TIME_FORMAT = 'HH:mm';
  static DATE_FORMAT = 'DD-MM-YYYY';
  static EXTRA_COST_REGISTRATION_BLOCK_HOURS_KEY =
    'WebPortalExtraCostRegistrationBlockHours';

  static OTHER_DOCUMENT_IDENTIFIER = 'OTHER';
  static CMR_DOCUMENT_IDENTIFIER = 'CMR';
  static VALIDATE_CMR_ENDPOINT = 'validate-cmr';
  static REQUIRES_CMR_VALIDATION_ENDPOINT = 'requires-cmr-validation';
  static NOTIFY_FMS_USER_OF_CMR_VALIDATION_ENDPOINT =
    'notify-fms-user-of-cmr-validation';
  static MAX_CMR_FILES_ALLOWED = 10;
  static MB_SIZE = 1000;
  static USER_NOT_FOUND = 'User not found or not bound to carrier';

  static VALID_ORDER_DOCUMENT_EXTENSION = ['jpg', 'jpeg', 'pdf', 'png'];
  static VALID_TENDER_DOCUMENT_EXTENSTION = [
    'jpg',
    'jpeg',
    'pdf',
    'png',
    'tiff',
    'docx',
    'txt',
  ];
  static VALID_INSTRUCTION_DOCUMENT_EXTENSTION = ['pdf'];
  static VALID_TENDER_BIDSHEET_DOCUMENT_EXTENSTION = ['xlsx', 'xls'];
  static MAX_ALLOWED_FILE_SIZE_MB = 10;
  static LANE_BID_TRANSIT_VALUES =
    ',A-A,A-B,A-C,A-D,A-E,A-F,A-G,A-H,A-I,A-J,A-K,A-L,A-M,A-N,A-O,A-P,A-Q,A-R,A-S,A-T,A-U,A-V,A-W,A-X,A-Y,A-Z';

  static ORDERS_OVERVIEW_URL = '/secure/order-list';
  static FREIGHT_EXCHANGE_URL = '/secure/freight-exchange';
  static SELF_BILLING_URL = '/secure/self-billing';
  static USERS_URL = '/secure/admin/users';
  static CARRIERS_URL = '/secure/admin/carriers';
  static CARRIERS_TO_APPROVE_URL = '/secure/admin/approve-carriers';
  static PORTAL_SETTINGS_URL = '/secure/admin/portal-settings';
  static EXWORK_ORDERS_OVERVIEW_URL = '/secure/ex-work-timeslot';
  static TENDERS_URL = '/secure/tender';
  static INSTRUCTION_DOCS_URL = '/secure/instruction-docs';
  static CMR_UPLOAD_URL = '/secure/order-list/cmr-upload';
  static INCIDENTS_URL = '/secure/incidents';
  static USERNAME_REGEX_MASK = '^[a-zA-Z0-9.-]+$';
  static EMAIL_REGEX_MAX = '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[.][a-zA-Z]{2,}$';
  static NO_TIMEZONE_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
  static NO_TIMEZONE_DATE_TIME_FORMAT_NO_SEC = 'YYYY-MM-DDTHH:mm';
  static VAT_REGEX = '^[A-Z0-9\s]*$';
  static WEBSITE_REGEX =
    '^(([w]+:)?//)?(([dw]|%[a-fA-fd]{2,2})+(:([dw]|%[a-fA-fd]{2,2})+)?@)?([dw][-dw]{0,253}[dw].)+[w]{2,4}(:[d]+)?(/([-+_~.dw]|%[a-fA-fd]{2,2})*)*(?(&amp;?([-+_~.dw]|%[a-fA-fd]{2,2})=?)*)?(#([-+_~.dw]|%[a-fA-fd]{2,2})*)?$';
}
